import axios from 'axios';
export class ProductAPI {

  constructor() {
    this.client = axios.create({
      headers: {
        'X-CSRF-Token': window.csrfToken,
        'Content-type': 'application/json'
      }
    });
  }

  async fetch(url, body) {
    return await this.client.post(
      url, Object.assign({ CSRF_TOKEN: window.csrfToken }, body)
    );
  }

  async getProductTitles() {
    return await this.fetch(`/search/get-search-titles`);
  }
}


// WEBPACK FOOTER //
// ./source/scripts/products/lib/api.js